<template>
  <div class="seafirmscont">
    <div class="conttitle">合肥债权债务律师</div>
    <div class="contmidd between">
      <div class="seazc">
        <div class="firmslist">
          <div class="firmsitem flex_start" v-for="item in 5" :key="item">
            <div class="cover">
              <img src="../../../assets/search/sealawcove_sample.png" />
            </div>
            <div class="Lawfirms">
              <div class="name">张三律师</div>
              <div class="zhiye flex_start">
                <span
                  >执业年限：执业
                  <span class="re">3</span>
                  年</span
                >
                <span class="xxxxx">|</span>
                <span class="flex_start"
                  ><img src="../../../assets/base/zuobiao.png" alt="" />
                  河北-邢台</span
                >
              </div>
              <div class="zy">
                专长领域：
                {{
                  `证券市场、工程及房地产、公司经营、婚姻家庭、遗产继承、房屋土地、
                民事诉讼、商事仲裁、刑事诉讼、国家赔偿` | toEllipsisFilter(70)
                }}
              </div>
              <div class="shouxia flex_start">
                <span class="tag tag1">口碑好</span>
                <span class="tag tag2">已实名</span>
                <span class="tag tag3">经验足</span>
              </div>
              <div class="lxbtn flex_end">
                <div class="btn btn1">关注+</div>
                <div class="btn btn2">立即咨询</div>
              </div>
              <div class="lawstatus flex_start" v-if="item % 2 == 1">
                <img src="../../../assets/search/lawstatus_1.png" />在线
              </div>

              <div class="lawstatus flex_start" v-else>
                <img src="../../../assets/search/lawstatus_0.png" />离线
              </div>
            </div>
          </div>
        </div>

        <div class="pagination mt30">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-count="pageCount"
            :current-page="currentPage"
            :pager-count="5"
            @current-change="turnpage"
            @prev-click="turnpage(--currentPage)"
            @next-click="turnpage(++currentPage)"
          >
          </el-pagination>
        </div>
      </div>
      <div class="searc">
        <speltfocblem class="common" />
        <findlawtip class="common mt30" />
      </div>
    </div>
  </div>
</template>

<script>
import speltfocblem from "views/speciallist/components/speltfocblem";
import findlawtip from "views/seafirms/components/findlawtip";
export default {
  components: {
    speltfocblem,
    findlawtip,
  },
  data: () => ({
    currentPage: 1, //当前
    pageCount: 17, //总页数
    total: 17, //总条目
  }),
  methods: {
    turnpage(e) {
      console.log(e);
    },
  },
};
</script>

<style lang="scss" scoped>
.seafirmscont {
  width: 1200px;
  margin: 0 auto;
  padding: 0 0 70px;
  .conttitle {
    font-size: 20px;
    color: #333333;
    margin-bottom: 30px;
  }
  .contmidd {
    align-items: flex-start;
    .common {
      background: #ffffff;
    }
    .seazc {
      width: 856px;
      padding-bottom: 50px;
      background-color: #fff;

      .firmslist {
        .firmsitem {
          padding: 24px 32px 24px 56px;
          position: relative;
          cursor: pointer;
          .cover {
            margin-right: 30px;
            img {
              width: 142px;
              height: 142px;
              background: #0385d0;
              border-radius: 50%;
            }
          }
          .Lawfirms {
            .name {
              font-size: 18px;
              color: #333333;
            }
            .zhiye {
              margin-top: 10px;
              font-size: 14px;
              color: #999999;

              img {
                width: 10px;
                height: 12px;
                margin-right: 4px;
              }
              .re {
                color: #e30000;
              }
              .xxxxx {
                margin: 0 10px;
              }
            }
            .zy {
              margin-top: 10px;
              font-size: 12px;
              height: 44px;
              color: #999999;
              line-height: 22px;
            }
            .shouxia {
              margin-top: 10px;
              .tag {
                padding: 2px 6px;
                font-size: 14px;
                border-radius: 3px;
                margin-right: 20px;
                &.tag1 {
                  color: #0465ea;
                  background: #deecff;
                }
                &.tag2 {
                  color: #ea8604;
                  background: #fff0de;
                }
                &.tag3 {
                  color: #0486ea;
                  background: #def8ff;
                }
              }
            }
            .lxbtn {
              position: absolute;
              bottom: 10px;
              transform: translateY(-50%);
              right: 32px;
              .btn {
                padding: 6px 20px;
                border-radius: 18px;
                font-size: 14px;
                margin-left: 20px;
                &.btn1 {
                  color: #0465ea;
                  background: #ffffff;
                  border: 1px solid #0465ea;
                }
                &.btn2 {
                  color: #fff;
                  background: #0465ea;
                }
              }
            }
          }
          .lawstatus {
            position: absolute;
            top: 30px;
            right: 30px;
            font-size: 14px;
            color: #333333;
            img {
              width: 12px;
              height: 12px;
              margin-right: 5px;
            }
          }

          &:last-child {
            border-bottom: none;
          }
          &:hover {
            box-shadow: 1px 1px 6px 0px rgba(0, 0, 0, 0.08);
          }
        }
      }

      .pagination {
        text-align: center;
        ::v-deep .el-pagination.is-background .btn-next,
        ::v-deep .el-pagination.is-background .btn-prev,
        ::v-deep .el-pagination button,
        ::v-deep .el-pagination span:not([class*="suffix"]),
        ::v-deep .el-pagination.is-background .el-pager li {
          min-width: 36px;
          height: 36px;
          line-height: 36px;
        }
        ::v-deep
          .el-pagination.is-background
          .el-pager
          li:not(.disabled).active,
        ::v-deep
          .el-pagination.is-background
          .el-pager
          li:not(.disabled):hover {
          color: #ffffff !important;
          background: #0057ff !important;
        }
      }
    }
    .searc {
      width: 314px;
    }
  }
}
</style>